/**
 * User Rota Repository
 * CRUD for user_routa (user–store weekly day/shift assignments)
 */

import { apiClient } from '../../client'
import type { PaginatedResponse } from '../role.repository'

export interface UserRouta {
    id: number
    tenant_id: number
    user_id: number
    store_id: number
    sat: number
    sat_shift: number
    sun: number
    sun_shift: number
    mon: number
    mon_shift: number
    tue: number
    tue_shift: number
    wed: number
    wed_shift: number
    thu: number
    thu_shift: number
    fri: number
    fri_shift: number
    created_by?: number | null
    updated_by?: number | null
    created_at: string
    updated_at: string
    user?: { id: number; en_name: string; username?: string }
    store?: { id: number; en_name: string }
}

export interface CreateUserRoutaRequest {
    tenant_id?: number
    user_id: number
    store_id: number
    sat?: number
    sat_shift?: number
    sun?: number
    sun_shift?: number
    mon?: number
    mon_shift?: number
    tue?: number
    tue_shift?: number
    wed?: number
    wed_shift?: number
    thu?: number
    thu_shift?: number
    fri?: number
    fri_shift?: number
}

export interface UpdateUserRoutaRequest extends Partial<CreateUserRoutaRequest> {}

class UserRoutaRepository {
    async getAll(
        page: number = 1,
        limit: number = 10,
        filters?: { user_id?: number; store_id?: number }
    ): Promise<PaginatedResponse<UserRouta>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })
        if (filters?.user_id != null) params.append('user_id', String(filters.user_id))
        if (filters?.store_id != null) params.append('store_id', String(filters.store_id))
        return apiClient.get<PaginatedResponse<UserRouta>>(`/user-routa?${params.toString()}`)
    }

    async getById(id: number): Promise<UserRouta> {
        return apiClient.get<UserRouta>(`/user-routa/${id}`)
    }

    async create(data: CreateUserRoutaRequest): Promise<UserRouta> {
        return apiClient.post<UserRouta>('/user-routa', data)
    }

    async update(id: number, data: UpdateUserRoutaRequest): Promise<UserRouta> {
        return apiClient.put<UserRouta>(`/user-routa/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/user-routa/${id}`)
    }
}

export const userRoutaRepository = new UserRoutaRepository()
